import { render, staticRenderFns } from "./SoliHeader.vue?vue&type=template&id=329504ae&scoped=true"
import script from "./SoliHeader.vue?vue&type=script&lang=js"
export * from "./SoliHeader.vue?vue&type=script&lang=js"
import style0 from "./SoliHeader.vue?vue&type=style&index=0&id=329504ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329504ae",
  null
  
)

export default component.exports